import { Injectable } from "@angular/core";
import { Router} from "@angular/router";
import { LoadingService } from "@apply4u/services/loading.service";
import { ToasterMessageService } from "@apply4u/services/toaster-message.service";
import { CommonMessages } from '@apply4u/shared/constant/messages/common-messages';
import { SaveSearchServices } from "@apply4u/services/save-searches";
import { SaveSearches } from "@apply4u/models/save-searches";
import { AutoSearch as AutoSearchConst } from "@apply4u/shared/constant/auto-search";

import { NewUserCentricMesssages } from "@apply4u/shared/constant/messages/new-user-centric-header-messages";
import { ConfirmationMessages } from "@apply4u/shared/constant/messages/confirmation-messages";
import { EditSavedSearchMessages } from "@apply4u/shared/constant/messages/edit-saved-search-messages";
import { ContextService } from "../context-service";
import { UserAutoSaveSearch } from '@apply4u/models/user-save-search/user-auto-save-search';
import { ConfirmationService } from '@apply4u/shared/components/confirmation-modal/confirmation.service';
import { UserSaveSearchService } from "../user-searches/user-save-search.service";
import { IsAny, IsNotNull, IsNotNullOrEmpty, IsNotZero } from "@apply4u/shared/helpers/common/type-safe-helpers";
import { UserPackageConsumption } from "@apply4u/models/UserPackage";
import { PackageService } from "../package.Service";
import { AddOns } from '@apply4u/shared/constant/AddOns';

@Injectable({
  providedIn: 'root'
})
export class AutoSearchService {  
  redirectUrl: string;
  isNavigateAfterSave: boolean;
  navigateByUrl: string; 
  AutoSearchListPageUrl:string;

  constructor(
    private router: Router,    
    private loadingService: LoadingService,
    private toasterService: ToasterMessageService,
    private savedSearchService: SaveSearchServices,   
    private contextService: ContextService,
    private userSaveSearchService: UserSaveSearchService,
    private confirmationService: ConfirmationService,
    private packageService: PackageService) {   
      this.AutoSearchListPageUrl = '/my-auto-searches';   
    }

  ngOnInit(): void {
    if (this.contextService.IsBrowser) {
      this.redirectUrl = this.router.url;
    }    
  }

  ConfirmActiveSaveSearchHandler(autoSearch: SaveSearches, selectedDashboardTypeId: number) {
    this.loadingService.Show();
  
    if (this.contextService.IsUserLoggedIn) {
      if (IsNotNullOrEmpty(autoSearch.KeyWords)) {
        if (IsNotZero(autoSearch.Id)) {          
          this.UpdateSaveSearchHandler(autoSearch);
        } else {
          this.savedSearchService.GetUserSaveSearchesLimit(this.contextService.LoggedInUserId, selectedDashboardTypeId).subscribe(saveSearchLimit => {
            if (IsNotNull(saveSearchLimit)) {
              if (saveSearchLimit.AutoSearchesCount < saveSearchLimit.SavedSearchesLimit) {
                if (saveSearchLimit.CanUserSaveSearch) {
                  autoSearch.IsActive = true;
                  this.SaveSearchHandler(autoSearch);
                } else {
                  this.loadingService.Hide();
                  this.confirmationService.SetMessage(ConfirmationMessages.ConfirmationOnAutoSearchMarkAsActive).OpenConfirmationDialogue((confrim: any) => {
                    if (confrim) {
                      this.savedSearchService.DeactivateOldestSaveSearch(this.contextService.LoggedInUserId, selectedDashboardTypeId).subscribe(result => {
                        autoSearch.IsActive = true;
                        this.SaveSearchHandler(autoSearch);
                      },error=>{
                        this.loadingService.Hide();
                        this.NavigateByUrl();
                      });
                    } else {
                      autoSearch.IsActive = false;
                      this.SaveSearchHandler(autoSearch);
                    }
                  });
                }
              } else {
                this.loadingService.Hide();
                this.toasterService.Error(`You cannot store more than ${saveSearchLimit.SavedSearchesLimit} auto searches. Please delete one of your existing ones and try again.`);               
                this.NavigateByUrl();
              }
            }
          }, errorResult => {
            this.loadingService.Hide();
            this.toasterService.Error(CommonMessages.OnSomethingWentWrongError, null);   
            this.NavigateByUrl();       
          });
        }
      } else {
        this.loadingService.Hide();
        this.toasterService.Error(AutoSearchConst.onSubmitKeywordsNotExistError);
      }

    } else {     
      this.contextService.SignInRedirect();
    }
  }

  SaveSearchHandler(saveSearches: SaveSearches) {
    this.loadingService.Show();
    this.savedSearchService.IsSaveSearchExists(saveSearches).subscribe(isSaveSearchExist => {
      if (isSaveSearchExist) {
        this.loadingService.Hide();
        this.toasterService.Error(NewUserCentricMesssages.OnSavingSavedSearchAlreadyExistsError);        
        this.NavigateByUrl();
      } else {

        if (IsNotNull(saveSearches)) {

          if (saveSearches.IsJobSearch == true || saveSearches.IsCvSearch == true) {

            saveSearches.UserId = this.contextService.LoggedInUserId;

            if (IsNotNullOrEmpty(saveSearches.KeyWords) && IsNotNullOrEmpty(saveSearches.AllofTheseWords) && IsNotNullOrEmpty(saveSearches.AnyofTheseWords)) {

              saveSearches.IsBooleanSearch = false;

            } else if ((IsNotNullOrEmpty(saveSearches.AllofTheseWords)) || (IsNotNullOrEmpty(saveSearches.AnyofTheseWords))) {
              saveSearches.IsBooleanSearch = false;
            }

            this.savedSearchService.SaveSearches(saveSearches)
              .subscribe(res => {
                this.loadingService.Hide();
                this.toasterService.SavedSuccessfully();
                document.getElementById('AddWork').click();
                this.NavigateByUrl();
              },error=>{
                this.loadingService.Hide();
                this.NavigateByUrl();
              });          
          } else {
            this.toasterService.Error(AutoSearchConst.OnSubmitSearchTypeNotExistError);
            this.loadingService.Hide();            
            this.NavigateByUrl();
          }
        } else {
          this.loadingService.Hide();
          this.NavigateByUrl();
        }
      }
    },error=>{
      this.loadingService.Hide();
      this.NavigateByUrl();
    });
  }

  UpdateSaveSearchHandler(autoSearch: SaveSearches) {
    this.savedSearchService.UpdateSaveSearchId(autoSearch.Id, autoSearch).subscribe(result => {
      this.loadingService.Hide();
      this.toasterService.Success(EditSavedSearchMessages.OnUpdatingSavedSearchSuccess, null);
      document.getElementById('AddWork').click();
      
      this.NavigateByUrl();
    }, errorResult => {

      this.toasterService.Error(CommonMessages.OnSomethingWentWrongError, null);
      this.loadingService.Hide();
    });
  }

  NavigateByUrl() {
    if (this.isNavigateAfterSave) {
      this.router.navigateByUrl(this.navigateByUrl);
    }    
  }


  /// New Code As per New API's

  CreateConfirmAutoSaveSearchhandler(autoSearch: UserAutoSaveSearch, redirectToAutoSearchesPage: boolean = false) {
    if (this.contextService.IsUserLoggedIn) {
      if (IsNotNull(autoSearch)) {
        if (autoSearch.Id > 0) {
          this.UpdateUserSaveSearch(autoSearch, redirectToAutoSearchesPage);
        } else {
          this.userSaveSearchService.GetUserSearchesLimit(this.contextService.LoggedInUserId, this.contextService.UserTypeId).subscribe({
            next: limit => {
              if (IsNotNull(limit)) {
                if (limit.CanSave && limit.TotalAllowedLimit <= limit.PersonalLimit) {
                  autoSearch.IsActive = true;
                  this.SaveUserSearchHandler(autoSearch, redirectToAutoSearchesPage, true);
                } else {
                  this.loadingService.Hide();
                  this.confirmationService.SetTitle('Confirm Deletion.').SetMessage(ConfirmationMessages.ConfirmationOnAutoSearchMarkAsActive, "Confirm").OpenConfirmationDialogue(isConfirmed => {
                    if (isConfirmed) {
                      this.userSaveSearchService.DeactivateUserOldSearches(this.contextService.LoggedInUserId, this.contextService.UserTypeId).subscribe({
                        next: deactive => {
                          autoSearch.IsActive = true;
                          this.SaveUserSearchHandler(autoSearch, redirectToAutoSearchesPage, true);
                        }, error: error => {
                          this.loadingService.Hide();
                          this.toasterService.Error(CommonMessages.OnSomethingWentWrongError, null);
                        }
                      });
                    } else {
                      autoSearch.IsActive = false;
                      this.SaveUserSearchHandler(autoSearch, redirectToAutoSearchesPage, false);
                    }
                  });
                }
              }
            }, error: error => {
              this.loadingService.Hide();
              this.toasterService.Error(CommonMessages.OnSomethingWentWrongError, null);
            }
          });
        }
      } else {
        this.loadingService.Hide();
        this.toasterService.Error(AutoSearchConst.onSubmitKeywordsNotExistError);
      }
    } else {
      this.contextService.SignInRedirect();
    }
  }

  UpdateUserSaveSearch(autoSearch: UserAutoSaveSearch, redirectToAutoSearchesPage: boolean = false) {
    if (IsNotZero(autoSearch.Id)) {
      this.isNavigateAfterSave = true;
      this.loadingService.Show();
      this.userSaveSearchService.UpdateUserSaveSearch(autoSearch.Id, this.contextService.LoggedInUserId, autoSearch).subscribe({
        next: update => {
          this.loadingService.Hide();
          this.toasterService.Success(EditSavedSearchMessages.OnUpdatingSavedSearchSuccess, null);

          if (redirectToAutoSearchesPage) {
            this.RedirectListPage();
          } else {
            let elementAddWork = document.getElementById('AddWork');

            if (IsNotNull(elementAddWork)) {
              elementAddWork.click();
            }

            let element = document.getElementById('AutoSaveSearchConfirmationModal');

            if (IsNotNull(element)) {
              element.click();
            }
          }
        }, error: error => {
          this.toasterService.Error(CommonMessages.OnSomethingWentWrongError, null);
          this.loadingService.Hide();
        }
      });
    }
  }

  SaveUserSearchHandler(autoSearch: UserAutoSaveSearch, redirectToAutoSearchesPage: boolean = false, isPackageConsume: boolean = false) {
    if (IsNotNull(autoSearch)) {
      this.loadingService.Show();
      this.userSaveSearchService.IsUserSearchExists(this.contextService.LoggedInUserId, autoSearch).subscribe({
        next: isExist => {
          if (isExist) {
            this.loadingService.Hide();
            this.toasterService.Error(NewUserCentricMesssages.OnSavingSavedSearchAlreadyExistsError);
          } else {
            if (autoSearch.IsJobSearch == true || autoSearch.IsCvSearch == true) {
              this.userSaveSearchService.SaveUserSearches(this.contextService.LoggedInUserId, autoSearch).subscribe({
                next: searchId => {
                  if (isPackageConsume == true) {
                    this.ConsumeUserPackage(autoSearch, searchId);
                  }

                  this.loadingService.Hide();
                  this.toasterService.Success(EditSavedSearchMessages.OnCreateSavedSearchSuccess, null);
                  if (redirectToAutoSearchesPage) {
                    this.RedirectListPage();
                  } else {
                    let elementAddWork = document.getElementById('AddWork');

                    if (IsNotNull(elementAddWork)) {
                      elementAddWork.click();
                    }

                    let element = document.getElementById('AutoSaveSearchConfirmationModal');

                    if (IsNotNull(element)) {
                      element.click();
                    }
                  }
                }, error: error => {
                  this.loadingService.Hide();
                  this.toasterService.Error(CommonMessages.OnSomethingWentWrongError, null);
                }
              });
            } else {
              this.toasterService.Error(CommonMessages.OnSomethingWentWrongError, null);
              this.loadingService.Hide();
            }
          }
        }, error: error => {
          this.loadingService.Hide();
          this.toasterService.Error(CommonMessages.OnSomethingWentWrongError, null);
        }
      });
    } else {
      this.loadingService.Hide();
      this.toasterService.Error(CommonMessages.OnSomethingWentWrongError, null);
    }
  }

  RedirectListPage() {
    this.router.navigateByUrl(this.AutoSearchListPageUrl);
  }

  ConsumeUserPackage(autoSearch: UserAutoSaveSearch, referenceId: number): void {
    let userPackageConsumption = new UserPackageConsumption();

    userPackageConsumption.UserId = this.contextService.LoggedInUserId;
    userPackageConsumption.AddOnId = (autoSearch.IsJobSearch == true) ? AddOns.JobAlertsAddOnsId : 26;
    userPackageConsumption.referenceId = referenceId;
    userPackageConsumption.referenceType = (autoSearch.IsJobSearch == true) ? 1 : 6;
    userPackageConsumption.consumdOn = new Date();

    this.packageService.savePackageConsumedHistory(userPackageConsumption).subscribe(userPkgConsumption => {
    });
  }

  CreateMultiJobTitlesBooleanQuery(selectedMultiJobTitles: string[]): string {
    let jobKeywords: string = "";
    let jobTitleList: string[] = [];

    if (IsAny(selectedMultiJobTitles)) {
      selectedMultiJobTitles.forEach(item => {
        if (IsNotNullOrEmpty(item)) {
          const jobTitleParts = item.split(" ");
          let keywords = "";

          if (IsAny(jobTitleParts)) {
            var count = 0;

            jobTitleParts.forEach(part => {
              if (IsNotNullOrEmpty(part)) {
                if (count == 0) {
                  keywords = `${keywords}${part}`;
                  count++;
                } else {
                  keywords = `${keywords} AND ${part}`;
                }
              }
            });

            const jobTitle = `"${item.trim()}" OR (${keywords})`;
            jobTitleList.push(jobTitle);
          }
        }
      });

      if (IsAny(jobTitleList)) {
        jobKeywords = jobTitleList.join(" OR ");
      }
    }

    return jobKeywords;
  }  

}
